export const EPartnerInformationSection = {
  PARTNER_ONBOARDING: "partner_onboarding",
} as const;

export type TPartnerInformationSection =
  (typeof EPartnerInformationSection)[keyof typeof EPartnerInformationSection];
